import { render } from "./IconMore.vue?vue&type=template&id=63f56ade"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconMore.vue"]])

export default __exports__